export function Delay(delayMilliSecond: number = 100): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, delayMilliSecond));
}
